export default __webpack_public_path__ + "static/media/saison_active.4d58200b.svg";